import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Account } from '../interfaces/account';

@Injectable({
  providedIn: 'root'
})
export class AccountApiService {

  private http = inject(HttpClient);
  private url = environment.apiUrl + 'account/';

  constructor() { }

  getAccounts(): Observable<any[]> {
      return this.http.get<Account[]>(this.url);
  }

  createAccount(account: Account): Observable<any[]> {
      return this.http.post<any>(this.url, account);
  }

  updateAccount(id: string, account: Account): Observable<any[]> {
      return this.http.put<any>(this.url + id, account);
  }

}

